import React,{Component} from 'react';
import { firebaseAuth,ref,storage } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

class Profile extends Component{
    constructor(){
        super();
        this.updateProfile = this.updateProfile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.HandleDashboardColor = this.HandleDashboardColor.bind(this);
        this.state = {
            userId:"",
            user :{},
            path :""
        
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                        let image = data.val().image
                        storage.child("Admin").child(image).getDownloadURL().then(function(url){
                            this.setState({
                            path : url
                            })
                        }.bind(this))
                    }.bind(this));           
            }else{
              this.props.history.push("/login");
            }
        });       
    }


    updateProfile(event){
        event.preventDefault();
        const updatedProfile = this.state.user;
        ref.child("users").child(`/${this.props.match.params.uid}`).update(updatedProfile).then(()=>{
            alert("Profile updated successfully");
        });
    }

    handleChange(e){
        const updateUser = this.state.user
        const update ={
            ...updateUser,
            [e.target.name]:e.target.value
        } 
        this.setState({user:update})   
    }
    
    HandleDashboardColor(color) {
        const updateUser = this.state.user
        const update ={
            ...updateUser,
            dashboardColor : color
        } 
        this.setState({user:update})
    }

    render() {
        const user = this.state.user
        console.log(user);
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Profile" />
                            <div className="block">
                              <form className="form-horizontal form-bordered"  onSubmit={this.updateProfile} >
                                <div className="form-group">
                                    <label className="col-md-3 control-label" >First Name</label>
                                    <div className="col-md-4">
                                        <input className="form-control" value={this.state.user.firstname} name="firstname"  type="text" onChange={this.handleChange} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label">Last Name</label>
                                    <div className="col-md-4">
                                        <input className="form-control" value={this.state.user.lastname} name="lastname"  type="text" onChange={this.handleChange} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label" >Gender</label>
                                    <div className="col-md-4">
                                        <select className="select-chosen"  name="gender" value={this.state.user.gender} onChange={this.handleChange} >
                                          <option value="Male">Male</option>
                                          <option value="Female">Female</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-3 control-label" >Phone Number</label>
                                    <div className="col-md-4">
                                        <input className="form-control" name="phone" value={!this.state.user.phone ? "" : this.state.user.phone} type="text" onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-3 control-label" >Address</label>
                                    <div className="col-md-4">
                                        <input className="form-control"  value = {!this.state.user.address ? "" : this.state.user.address} name="address"  type="text"  onChange={this.handleChange}/>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label">Dashboard Color</label>
                                    <div className="col-md-4">
                                        <ul className="sidebar-section sidebar-themes clearfix sidebar-nav-mini-hide">
                                            <li><a onClick={ () => this.HandleDashboardColor("default") } href="javascript:void(0)" className="themed-background-dark-default themed-border-default" data-theme="default" data-toggle="tooltip" title="Default Blue"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/night.css") }  href="javascript:void(0)" className="themed-background-dark-night themed-border-night" data-theme="css/themes/night.css" data-toggle="tooltip" title="Night"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/amethyst.css") }  href="javascript:void(0)" className="themed-background-dark-amethyst themed-border-amethyst" data-theme="css/themes/amethyst.css" data-toggle="tooltip" title="Amethyst"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/modern.css") }  href="javascript:void(0)" className="themed-background-dark-modern themed-border-modern" data-theme="css/themes/modern.css" data-toggle="tooltip" title="Modern"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/autumn.css") } href="javascript:void(0)" className="themed-background-dark-autumn themed-border-autumn" data-theme="css/themes/autumn.css" data-toggle="tooltip" title="Autumn"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/flatie.css") } href="javascript:void(0)" className="themed-background-dark-flatie themed-border-flatie" data-theme="css/themes/flatie.css" data-toggle="tooltip" title="Flatie"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/spring.css") } href="javascript:void(0)" className="themed-background-dark-spring themed-border-spring" data-theme="css/themes/spring.css" data-toggle="tooltip" title="Spring"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/fancy.css") } href="javascript:void(0)" className="themed-background-dark-fancy themed-border-fancy" data-theme="css/themes/fancy.css" data-toggle="tooltip" title="Fancy"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/fire.css") } href="javascript:void(0)" className="themed-background-dark-fire themed-border-fire" data-theme="css/themes/fire.css" data-toggle="tooltip" title="Fire"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/coral.css") } href="javascript:void(0)" className="themed-background-dark-coral themed-border-coral" data-theme="css/themes/coral.css" data-toggle="tooltip" title="Coral"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/lake.css") } href="javascript:void(0)" className="themed-background-dark-lake themed-border-lake" data-theme="css/themes/lake.css" data-toggle="tooltip" title="Lake"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/forest.css") } href="javascript:void(0)" className="themed-background-dark-forest themed-border-forest" data-theme="css/themes/forest.css" data-toggle="tooltip" title="Forest"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/waterlily.css") } href="javascript:void(0)" className="themed-background-dark-waterlily themed-border-waterlily" data-theme="css/themes/waterlily.css" data-toggle="tooltip" title="Waterlily"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/emerald.css") } href="javascript:void(0)" className="themed-background-dark-emerald themed-border-emerald" data-theme="css/themes/emerald.css" data-toggle="tooltip" title="Emerald"></a></li>
                                            <li><a onClick={ () => this.HandleDashboardColor("css/themes/blackberry.css") } href="javascript:void(0)" className="themed-background-dark-blackberry themed-border-blackberry" data-theme="css/themes/blackberry.css" data-toggle="tooltip" title="Blackberry"></a></li>
                                        </ul>
                                    </div>
                                </div>

                                

                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="example-file-input">Image</label>
                                    <div className="col-md-9">
                                       <img src={this.state.path} alt="avatar" height = "150" width = "150"/> 
                                    </div>
                                </div>
                                <div className="form-group form-actions">
                                    <div className="col-md-9 col-md-offset-3">
                                        <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Update Profile</button>
                                    </div>
                                </div>
                              </form>                                
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            
        );
    }
}

export default  Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js